import { memo } from 'react';
import { useTranslation } from '@betty/i18n';
import { useSelector } from '@betty/toolkit/state';
import { Box, Text } from '@betty/moonlight';
import { selectDepositCount } from '../../../state';
import {
  calculateReward,
  getRewardLabel,
  getPromoLocked,
} from './Promos.utils';
import { PromosProps } from './Promos.types';
import Promo from './Promo/Promo';
import NoPromo from './NoPromo/NoPromo';

function Promos({
  promos,
  limitReached,
  selectedAmount,
  selectedPromoIds,
  onSelectPromo,
  onSelectNoPromo,
}: PromosProps) {
  const { t } = useTranslation('wallet');
  const depositCount = useSelector(selectDepositCount);

  return (
    <Box gap="space-200">
      <Text
        variant="body-m"
        locNS="wallet"
        locKey="depositPromoTitle"
        color="darkSurfacePrimary"
        paddingBottom="space-200"
      />
      {promos?.ids.map((promoId) => {
        const promo = promos?.byId[promoId];
        const locked = getPromoLocked(promo, selectedAmount);
        const label = promo.subTypeMeta?.percentage
          ? calculateReward(promo, selectedAmount)
          : getRewardLabel(promo, t);

        return (
          <Promo
            key={promoId}
            label={label}
            locked={locked || limitReached}
            selected={selectedPromoIds.includes(promoId) && !limitReached}
            onPress={locked ? undefined : onSelectPromo}
            {...promo}
          />
        );
      })}
      {depositCount !== undefined && depositCount > 0 && (
        <NoPromo
          selected={!selectedPromoIds.length || limitReached}
          onPress={onSelectNoPromo}
        />
      )}
    </Box>
  );
}

export default memo(Promos);
